import React, { useState } from 'react';
import suppliersListData from '../../../data/suppliersListData.json';
import DefaultModal from '../../components/modals/DefaultModal';
import ReviewSupplierScreen from './ReviewSupplierScreen';

const searchTerms = ['Surface Hardening', 'Shot Pinning', 'Surface Hardening'];

const SupplierListScreen = ({ handleTabChange }) => {
  const [checkedItems, setCheckedItems] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [reviewSupplier, setReviewSupplier] = useState(null);

  const handleCheckboxChange = (event, index) => {
    event.stopPropagation();
    setCheckedItems({
      ...checkedItems,
      [index]: !checkedItems[index], // toggle the checked state
    });
  };

  const renderStars = (reviewCount) => {
    let stars = [];
    for (let i = 0; i < reviewCount; i++) {
      stars.push(<span key={i}>⭐</span>);
    }
    return stars;
  };

  return (
    <div className="flex flex-col">
      {reviewSupplier ? (
        <div>
          <ReviewSupplierScreen
            supplierData={reviewSupplier}
            setReviewSupplier={setReviewSupplier}
          />
        </div>
      ) : (
        <div>
          <div className="flex flex-row">
            {searchTerms &&
              searchTerms.map((option, index) => (
                <div
                  key={index}
                  className="m-1 px-2 py-1 rounded-xl text-[13.33px] text-center font-normal overflow-hidden
                        bg-[#D9D9D9]"
                >
                  {option}
                </div>
              ))}
          </div>
          <div className="flex flex-col space-y-3 mt-3">
            {suppliersListData &&
              suppliersListData['data'] &&
              suppliersListData['data'].map((data, index) => (
                <div
                  className={`grid grid-cols-[50px_50px_200px_200px_200px_200px] gap-4 max-w-fit border border-neutral-300 rounded-lg items-center p-2 ${
                    checkedItems[index] ? 'bg-[#8B5CF6] text-white' : ''
                  }`}
                >
                  <div className="items-center">
                    <input
                      type="checkbox"
                      className="ml-3 mt-2 form-checkbox h-5 w-5 text-indigo-600"
                      checked={checkedItems[index] || false}
                      onChange={(event) => handleCheckboxChange(event, index)}
                    />
                  </div>
                  <div
                    className="grid grid-cols-subgrid col-span-5 hover:cursor-pointer"
                    onClick={() =>
                      setReviewSupplier(suppliersListData['data'][index])
                    }
                  >
                    <img
                      alt="Logo"
                      src="/Rectangle_107.png"
                      className="h-12 w-12"
                    />
                    <div className="flex flex-col items-center">
                      <p className="text-[14px]">Supplier Name</p>
                      <p className="text-[14px] font-bold">
                        {data.supplier_name}
                      </p>
                    </div>
                    <div className="flex flex-col items-center">
                      <p className="text-[14px]">Rating</p>
                      <p className="text-[14px] font-bold">
                        {renderStars(data.rating)}
                      </p>
                    </div>
                    <div className="flex flex-col items-center">
                      <p className="text-[14px]">Availibilty</p>
                      <p className="text-[14px] font-bold">{data.avaibility}</p>
                    </div>
                    <div className="flex flex-col items-center">
                      <p className="text-[14px]">Matching Score</p>
                      <p className="text-[14px] font-bold">
                        {data.matching_score}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="flex flex-row items-center justify-center space-x-4 mt-5">
            <button
              className="rounded-full px-8 py-2 text-[18px] text-left my-1 border-[1px] border-black"
              onClick={() => handleTabChange('rfq_overview')}
            >
              Back
            </button>
            <button
              className="rounded-full px-8 py-2 text-[18px] text-left my-1 bg-blue-400 font-bold text-white"
              onClick={() => setShowModal(true)}
            >
              Send Bid
            </button>
          </div>

          {showModal && (
            <DefaultModal
              heading="Now Lets Wait!"
              MainData="Now wait for supplier to connect"
              SecondaryData=""
              ReturnTitle="Choose Supplier to get finish with this"
              ButtonTitle="Choose"
              ButtonLink="/dashboard?tab=my_quotes"
              handleTabChange={handleTabChange}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default SupplierListScreen;
